export default "__VITE_ASSET__C0ov3qMH__"